import { callEdgeFunction } from '../shared/api'

function failure(err) {
  return {
    data: null,
    error: err.message,
    code: err.code || null,
    retry: err.retry === true || (!err.status || err.status >= 500),
  }
}

export async function fetchTaHome(token) {
  try {
    const data = await callEdgeFunction(
      'portal-ta-home',
      { token },
      { cache: false },
    )
    return { data, error: null, code: null, retry: false }
  } catch (err) {
    console.error('TA home load failed:', err)
    return failure(err)
  }
}

export async function submitTaAction(token, payload) {
  try {
    const data = await callEdgeFunction(
      'portal-ta-actions',
      { token, ...payload },
      { cache: false },
    )
    return { data: data?.data || null, error: null, code: null, retry: false }
  } catch (err) {
    console.error('TA action failed:', err)
    return failure(err)
  }
}
